module.exports = __webpack_public_path__ + "52e07b0f37928dcffc4e8ef394ea888c.MP3";